import { createFileRoute } from "@tanstack/react-router";
import { EventForm } from "@/components/EventForm";

export const Route = createFileRoute("/_authenticated/events_/new")({
  component: CreateEventPage,
  head: () => ({
    meta: [
      { title: "Создать мероприятие — Turkey Drive" },
      {
        name: "description",
        content:
          "Создай своё мероприятие для сообщества Turkey Drive: место, дата, стоимость и соорганизатор.",
      },
      { property: "og:title", content: "Создать мероприятие — Turkey Drive" },
      {
        property: "og:description",
        content: "Организуй встречу для русскоязычного сообщества в Турции.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
});

function CreateEventPage() {
  return <EventForm />;
}
